import { Phone, ExternalLink, Reply, Image as ImageIcon, Video, FileText, MapPin } from "lucide-react";

const MEDIA_HEADER = {
  IMAGE:    { Icon: ImageIcon, label: "Imagem" },
  VIDEO:    { Icon: Video,     label: "Vídeo" },
  DOCUMENT: { Icon: FileText,  label: "Documento" },
  LOCATION: { Icon: MapPin,    label: "Localização" },
};

function findComponent(components, type) {
  return Array.isArray(components) ? components.find((c) => c?.type === type) : null;
}

function applyExamples(text, exampleArr) {
  if (!text) return "";
  if (!Array.isArray(exampleArr) || exampleArr.length === 0) return text;
  return text.replace(/\{\{(\d+)\}\}/g, (m, n) => {
    const idx = parseInt(n, 10) - 1;
    return exampleArr[idx] != null ? exampleArr[idx] : m;
  });
}

export default function TemplatePreview({ components }) {
  const header = findComponent(components, "HEADER");
  const body = findComponent(components, "BODY");
  const footer = findComponent(components, "FOOTER");
  const buttonsBlock = findComponent(components, "BUTTONS");

  const bodyExamples = body?.example?.body_text?.[0];
  const renderedBody = applyExamples(body?.text, bodyExamples);
  const mediaHeader = header?.format ? MEDIA_HEADER[header.format] : null;

  return (
    <div className="bg-[#0b1418] rounded-lg p-4 border border-white/[0.06]">
      <div className="text-xs text-ink-4 mb-3">Pré-visualização no WhatsApp</div>

      <div className="bg-[#202c33] rounded-lg overflow-hidden max-w-sm shadow-lg">
        <div className="bg-[#005c4b] px-3 py-2 text-xs text-emerald-100">
          Mensagem de modelo
        </div>

        {mediaHeader && (
          <div className="m-2 mb-0 h-28 rounded-md bg-[#0b1418] border border-white/[0.06] grid place-items-center text-ink-4">
            <div className="flex flex-col items-center gap-1 text-xs">
              <mediaHeader.Icon className="w-6 h-6" />
              {mediaHeader.label}
            </div>
          </div>
        )}

        <div className="p-3 text-sm space-y-2 text-ink-1">
          {header?.format === "TEXT" && header?.text && (
            <div className="font-semibold text-white">{header.text}</div>
          )}

          {renderedBody && (
            <div className="whitespace-pre-wrap break-words leading-relaxed">{renderedBody}</div>
          )}

          {footer?.text && <div className="text-xs text-ink-3">{footer.text}</div>}
        </div>

        {Array.isArray(buttonsBlock?.buttons) && buttonsBlock.buttons.length > 0 && (
          <div className="border-t border-white/[0.08] divide-y divide-white/[0.08]">
            {buttonsBlock.buttons.map((b, i) => {
              let Icon = Reply;
              if (b.type === "URL") Icon = ExternalLink;
              if (b.type === "PHONE_NUMBER") Icon = Phone;
              return (
                <div
                  key={i}
                  className="px-3 py-2 text-sm text-[#53bdeb] flex items-center justify-center gap-2 font-medium"
                >
                  <Icon className="w-3.5 h-3.5" />
                  {b.text || "(sem texto)"}
                </div>
              );
            })}
          </div>
        )}

        {!renderedBody && !header?.text && !mediaHeader && !footer?.text && (
          <div className="p-6 text-center text-xs text-ink-4">
            Comece preenchendo o body do template
          </div>
        )}
      </div>
    </div>
  );
}
